module.exports = __webpack_public_path__ + "static/media/Guest.a2e43605.svg";